import React from 'react'
import cn from 'classnames'
import iconStyles from 'components/shared/icons/icons.module.scss'
import { Link } from 'lucide-react'

export default function LinkIcon(props) {
    const { contextStyles, hoverStyles, selectedStyles } = props
    return (
        <div
            className={cn(
                iconStyles.iconComp,
                iconStyles.fontIconComp,
                contextStyles,
                hoverStyles,
                selectedStyles,
            )}
        >
            <Link />
        </div>
    )
}
